import React from 'react';

const ANNEXE_IMAGES_BY_FAMILY = {
  B1: ['/annexes/levage/B1-1.png', '/annexes/levage/B1-2.png'],
  B2: ['/annexes/levage/B2-1.png', '/annexes/levage/B2-2.png', '/annexes/levage/B2-3.png'],
  B3: ['/annexes/levage/B3-1.png', '/annexes/levage/B3-2.png', '/annexes/levage/B3-3.png'],
  B4: ['/annexes/levage/B4-1.png', '/annexes/levage/B4-2.png'],
  B5: ['/annexes/levage/B5-1.png', '/annexes/levage/B5-2.png'],
  B6: ['/annexes/levage/B6-1.png', '/annexes/levage/B6-2.png', '/annexes/levage/B6-3.png', '/annexes/levage/B6-4.png'],
  B7: ['/annexes/levage/B7-1.png', '/annexes/levage/B7-2.png'],
  B8: ['/annexes/levage/B8-1.png', '/annexes/levage/B8-2.png', '/annexes/levage/B8-3.png'],
  B9: ['/annexes/levage/B9-1.png', '/annexes/levage/B9-2.png', '/annexes/levage/B9-3.png'],
  B10: ['/annexes/levage/B10-1.png', '/annexes/levage/B10-2.png'],
  B11: ['/annexes/levage/B11-1.png', '/annexes/levage/B11-2.png', '/annexes/levage/B11-3.png'],
  C1: ['/annexes/levage/C1-1.png'],
  D1: ['/annexes/levage/D1-1.png'],
};

const normalizeFamilyCode = (code) => {
  if (!code || typeof code !== 'string') return '';
  const match = code.trim().toUpperCase().match(/^(B\d+|C\d+|D\d+)/);
  return match ? match[1] : '';
};

const styles = {
  page: {
    width: '210mm',
    height: '297mm',
    background: 'white',
    overflow: 'hidden',
    pageBreakAfter: 'always',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  warning: {
    background: '#fef3c7',
    border: '2px solid #f59e0b',
    borderRadius: '10px',
    padding: '12px',
    margin: '12px 16px',
    textAlign: 'center',
    color: '#92400e',
    fontWeight: 700,
  },
  warningSub: {
    fontSize: '12px',
    color: '#a16207',
    marginTop: '6px',
    fontWeight: 500,
  },
};

export default function AnnexesLevageImages({ familleCode }) {
  const normalizedCode = normalizeFamilyCode(familleCode);
  const images = ANNEXE_IMAGES_BY_FAMILY[normalizedCode] || [];

  if (!normalizedCode || images.length === 0) {
    return (
      <div style={styles.warning} className="no-print">
        ⚠️ Annexe levage non configurée pour la famille {normalizedCode || 'inconnue'}
        <div style={styles.warningSub}>
          Ajoutez les pages d’annexe dans `public/annexes/levage/`.
        </div>
      </div>
    );
  }

  return (
    <>
      {images.map((src, index) => (
        <div key={`${normalizedCode}-${index}`} style={styles.page} className="pdf-page">
          <img src={src} alt={`Annexe levage ${normalizedCode} - page ${index + 1}`} style={styles.image} />
        </div>
      ))}
    </>
  );
}
